import React, { Fragment, Suspense } from "react";
import { metaTag } from "../Library/commomLib";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
const WelcomeComponent = React.lazy(() => import("../Components/RootComponents/WelcomeComponent"));
const WelcomePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <WelcomeComponent />
      </Suspense>
    </Fragment>
  );
};

export default WelcomePage;
